module.exports = __webpack_public_path__ + "media/src/images/top_covers/com_summer4_sea-5ec74deb56fbc840ddc2c060020e3ca4.png";